import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

export function ValidateMinBirth(control: AbstractControl): {[key: string]: any} | null  {


    if (control.parent && control.parent.get('dataNascita') && control.parent.get('dataNascita').value) {
        const today = new Date();
        const birthDate = new Date(control.parent.get('dataNascita').value);
        const a = today.getTime();
        const b = birthDate.getTime();

        return (a < b) ? { birthnotvalid: true } : null;
    }

    return null; // return null if validation is passed.
}

@Directive({
  selector: '[appMinBirthValidatorDirective]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: AppMinBirthValidatorDirective,
    multi: true
  }]
})
export class AppMinBirthValidatorDirective implements Validator {
  validate(control: AbstractControl): {[key: string]: any} | null {
    return ValidateMinBirth(control);
  }
}